import { render, staticRenderFns } from "./settingsPos.vue?vue&type=template&id=9208ddb4&scoped=true&"
import script from "./settingsPos.vue?vue&type=script&lang=js&"
export * from "./settingsPos.vue?vue&type=script&lang=js&"
import style0 from "./settingsPos.vue?vue&type=style&index=0&id=9208ddb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9208ddb4",
  null
  
)

export default component.exports